<app-profile-header
  [avatarPath]="employeeInformation$()?.avatarPath"
  [firstName]="employeeInformation$()?.firstName"
  [lastName]="employeeInformation$()?.lastName"
  [email]="employeeInformation$()?.email"
  (avatarSelected)="newAvatarSelected($event)"
></app-profile-header>

<div class="page-container">
  <app-heading
    icon="person"
    title="Persönliche Informationen"
    i18n-title
  ></app-heading>

  @if (loading$()) {
    <div class="loading-spinner-container">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
    <div class="section-container">
      <app-personal-information
        [employee]="employeeInformation$()"
      ></app-personal-information>
    </div>
  }
</div>

<div class="page-container">
  <app-heading icon="settings" title="Einstellungen" i18n-title></app-heading>

  @if (loading$()) {
    <div class="loading-spinner-container">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
    <div class="section-container">
      <app-profile-settings></app-profile-settings>
    </div>
  }
</div>
